// Lib
import TawkMessenger from './lib';

// Utilities
import { isValidString } from './utils/helper';

function install(app, options = {}) {
	const { propertyId, widgetId } = options;

	if (!isValidString(propertyId)) {
		console.error('[Tawk-messenger-vue warn]: You didn\'t specified \'propertyId\' property in the plugin.');
		return;
	}

	if (!isValidString(widgetId)) {
		console.error('[Tawk-messenger-vue warn]: You didn\'t specified \'widgetId\' property in the plugin.');
		return;
	}

	new TawkMessenger(app, options);

	app.config.globalProperties.$tawkMessenger = app
}


export {
	install
};